var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"medpadala-error-modal","title":"MEDPadala","centered":"","header-class":"align-items-center","title-class":"text-center flex-grow-1","hide-footer":"","body-class":"py-4"}},[_c('b-row',[_c('b-col',{staticClass:"mx-auto mb-2",attrs:{"cols":"9"}},[_c('div',{staticClass:"text-center mb-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/medpadala_error.svg"),"alt":"MEDPadala Error"}})]),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.medPadalaErrors))]),(
          _vm.medPadalaErrors && typeof _vm.medPadalaErrors !== 'object'
            ? _vm.medPadalaErrors.toLowerCase().includes('invalid pin')
            : _vm.medPadalaErrors
        )?_c('b-button',{staticClass:"text-uppercase py-2 border-0",style:({
          backgroundColor:
            _vm.webDesign && _vm.webDesign.design
              ? ((_vm.webDesign.design.main_color) + " !important")
              : null,
          color:
            _vm.webDesign && _vm.webDesign.design
              ? ((_vm.webDesign.design.button_text_color) + " !important")
              : null
        }),attrs:{"variant":"primary","block":"","pill":""},on:{"click":_vm.proceed}},[_vm._v(" Ok ")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }